import { createStore, applyMiddleware } from "redux";
import { persistStore } from "redux-persist";
import thunk from 'redux-thunk';
import rootReducer from "./rootReducer";

// Create the store and persistor
const store = createStore(rootReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { persistor }; 
export default store; 

export const configureStore = () => {
  return { store, persistor };
};
